<template>
  <div class="form">
    <div class="form-item">
      <div class="form-item-label required">
        Name
      </div>
      <div class="form-item-content">
        <input
          @blur="handleVerify('name')"
          class="input"
          v-model="model.name"
          maxlength="100"
          placeholder="Full name (First and lase name)*"
          type="text"
        >
        <div
          v-if="errorMap.name"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The Name is required
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label">
        Phone Number
      </div>
      <PhoneNumberFormItem
        :model="model"
        :country-list="countryList"
      />
    </div>
    <div class="form-item">
      <div class="form-item-label required">
        Country
      </div>
      <div class="form-item-content">
        <CountryFromItem
          :model="model"
          :country-list="countryList"
        />
        <div
          v-if="errorMap.country"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The Name is required
        </div>
      </div>
    </div>
    <div
      v-if="model.country === 'Brazil' || model.country === 'Chile'"
      class="form-item"
    >
      <div class="form-item-label" />
      <div class="form-item-content">
        <div class="extension">
          <div class="flag">
            {{ model.country === 'Brazil' ? 'CPF' : 'RUT' }}
          </div>
          <input
            @blur="handleVerify('extension')"
            class="input"
            v-model="model.extension"
            maxlength="32"
            :placeholder="model.country === 'Brazil' ? 'CPF Number*' : 'RUT Number*'"
            type="text"
          >
        </div>
        <div
          v-if="errorMap.extension"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          {{ `The ${ model.country === 'Brazil' ? 'CPF Number' : 'RUT Number' } is required` }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="form-item"
    />
    <div class="form-item">
      <div class="form-item-label required">
        Street Address
      </div>
      <div class="form-item-content">
        <input
          @blur="handleVerify('streetAddr')"
          class="input"
          v-model="model.streetAddr"
          maxlength="200"
          placeholder="Street name, company name*"
          type="text"
        >
        <div
          v-if="errorMap.streetAddr"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The Street Address is required
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label">
        Apt,suite,etc.(optional)
      </div>
      <div class="form-item-content">
        <input
          class="input"
          v-model="model.extAddr"
          placeholder="Apartment, suite, unit, building, floor, etc."
          type="text"
        >
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label required">
        State / Province
      </div>
      <div class="form-item-content">
        <input
          @blur="handleVerify('province')"
          class="input"
          v-model="model.province"
          placeholder="State / Province*"
          type="text"
        >
        <div
          v-if="errorMap.province"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The State / Province is required
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label required">
        City / Suburb
      </div>
      <div class="form-item-content">
        <input
          @blur="handleVerify('city')"
          class="input"
          v-model="model.city"
          placeholder="City / Suburb*"
          type="text"
        >
        <div
          v-if="errorMap.city"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The City / Suburb is required
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label required">
        Post Code
      </div>
      <div class="form-item-content">
        <input
          @blur="handleVerify('zip')"
          class="input"
          v-model="model.zip"
          maxlength="20"
          placeholder="Post Code"
          type="text"
        >
        <div
          v-if="errorMap.zip"
          class="error"
        >
          <Icon name="icon-warning-outline" />
          The Post Code is required
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="form-item-label">
        Email
      </div>
      <div class="form-item-content">
        <input
          class="input"
          v-model="model.email"
          maxlength="100"
          placeholder="Herrychen@gamil.com"
          type="text"
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Icon } from '@/components/Icon'
import storage from '@/utils/storage'
import PhoneNumberFormItem from './PhoneNumberFormItem.vue'
import CountryFromItem from './CountryFromItem.vue'
import { useCountryStore } from '@/pinia/country'
import { useShipStore } from '@/pinia/ship'

const model = ref({
  areaCodeImg: '', // 手机号国家图片
  searchImg: '', // 国家图片
  name: '',
  phoneCode: '',
  phone: '',
  country: '',
  countryCode: '',
  province: '',
  city: '',
  streetAddr: '',
  extAddr: '', // 详细地址
  zip: '', // 收件地址
  email: '',
  extension: ''
})

const errorMap = ref({
  name: false,
  country: false,
  province: false,
  city: false,
  streetAddr: false,
  zip: false,
  extension: false
})

const country = useCountryStore()
const ship = useShipStore()
const countryList = computed(() => country.list)

const handleVerify = (key) => {
  errorMap.value[key] = !model.value[key]
}

const initModel = () => {
  const cacheAddress = storage.get('addressForm')
  if (cacheAddress) {
    model.value = cacheAddress
  } else {
    model.value.phoneCode = ship.country.phoneCode
    model.value.areaCodeImg = ship.country.countryUrl
    model.value.searchImg = ship.country.countryUrl
    model.value.country = ship.country.countryName
    model.value.countryCode = ship.country.countryCode
  }
}

const fillInfo = (data) => {
  model.value.name = data.name
  model.value.phoneCode = data.phoneCode
  model.value.phone = data.phone
  model.value.streetAddr = data.streetAddr
  model.value.extAddr = data.extAddr
  model.value.province = data.province
  model.value.city = data.city
  model.value.zip = data.zip
  model.value.email = data.email

  const item = countryList.value.find(item => item.countryName === data.country)
  if (item) {
    model.value.country = item.countryName
    model.value.searchImg = item.countryUrl
    model.value.countryCode = item.countryCode
    model.value.areaCodeImg = item.countryUrl
  }
}

const validate = () => {
  let isValid = true
  Object.keys(errorMap.value).forEach(key => {
    errorMap.value[key] = model.value[key] === ''
  })

  // 不包含特殊国家 不校验extension
  if (!['Brazil', 'Chile'].includes(model.value.country)) {
    errorMap.value.extension = false
  }

  Object.keys(errorMap.value).forEach(key => {
    if (errorMap.value[key]) {
      isValid = false
    }
  })

  return new Promise((resolve, reject) => {
    if (isValid) {
      resolve(model.value)
    } else {
      reject(false)
    }
  })
}

onMounted(() => {
  initModel()
})

defineExpose({
  fillInfo,
  validate
})
</script>

<style lang='less' scoped>
.form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 30px;
  margin-top: 32px;
  padding-bottom: 32px;
  .form-item {
    .form-item-label {
      color: #232323;
      font-size: 14px;
      font-family: mon-600;
      &.required::after {
        content: '*';
        color: #CC1010;
      }
    }
    .form-item-content {
      margin-top: 8px;
      width: 390px;
      min-height: 40px;

      .extension {
        display: flex;
        gap: 12px;
        margin-top: 24px;

        .flag {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #b2b7c2;
          border-radius: 6px;
          padding: 0 16px;
          color: #232323;
          font-size: 14px;
          font-family: mon-500;
          background-color: #ebebeb;
          height: 40px;
        }
      }

      .input {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        border: none;
        outline: none;
        width: 100%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #ebf1f5;
        padding: 0 16px;
        &::placeholder {
          color: #b2b7c2;
          font-size: 12px;
          font-family: mon-500;
        }

        &:focus {
          border: 2px solid #232323;
        }
      }
      .error {
        color: #7A0505;
        font-size: 11px;
        font-family: mon-500;
        margin-top: 8px;
      }
    }
  }
}
</style>
